import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Search from "../../components/Search";
import {
  LessonsModal,
  ExamsModal,
  ClassroomsModal,
} from "../../components/modal";


// leadUsers = {
  
// }

export default function StudentsTable() {
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("Lessons");
  const [modalType, setModalType] = useState(null); // State to manage the modal type
  const navigate = useNavigate(); // Use navigate for navigation

  const students = [
    {
      name: "Tom Browns",
      email: "tombrowns@gmail.com",
      username: "09 May, 2024",
    },
    {
      name: "Tom Browns",
      email: "tombrowns@gmail.com",
      username: "09 May, 2024",
    },
    {
      name: "Tom Browns",
      email: "tombrowns@gmail.com",
      username: "09 May, 2024",
    },
    {
      name: "Tom Browns",
      email: "tombrowns@gmail.com",
      username: "09 May, 2024",
    },
    {
      name: "Tom Browns",
      email: "tombrowns@gmail.com",
      username: "09 May, 2024",
    },
    {
      name: "Tom Browns",
      email: "tombrowns@gmail.com",
      username: "09 May, 2024",
    },
    {
      name: "Tom Browns",
      email: "tombrowns@gmail.com",
      username: "09 May, 2024",
    },
    {
      name: "Tom Browns",
      email: "tombrowns@gmail.com",
      username: "09 May, 2024",
    },
    {
      name: "Tom Browns",
      email: "tombrowns@gmail.com",
      username: "09 May, 2024",
    },
    {
      name: "Tom Browns",
      email: "tombrowns@gmail.com",
      username: "09 May, 2024",
    },
    {
      name: "Tom Browns",
      email: "tombrowns@gmail.com",
      username: "09 May, 2024",
    },
  ];

  const filteredStudents = students.filter((student) =>
    student.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
    setModalType(e.target.value); // Set the modal type based on filter value
  };

  const closeModal = () => {
    setModalType(null); // Close the modal
  };

  const viewPerformance = () => {
    navigate("/performance/performancePage");
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-md m-3">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-8">
          <h1 className="text-[20px] font-bold text-[#400167]">All Students</h1>
          <div className="flex items-center gap-4 border rounded-full py-2 px-4 w-[700px]">
            <Search onSearch={handleSearch} />
          </div>
        </div>
        <ShowingCategoryOfStudent
          filter={filter}
          changeFilter={handleFilterChange}
        />
      </div>

      <Table students={filteredStudents} onViewPerformance={viewPerformance} />

      {/* Render modals conditionally */}
      <LessonsModal isOpen={modalType === "Lessons"} onClose={closeModal} />
      <ExamsModal isOpen={modalType === "Exams"} onClose={closeModal} />
      <ClassroomsModal
        isOpen={modalType === "Classrooms"}
        onClose={closeModal}
      />
    </div>
  );
}

function ShowingCategoryOfStudent({ filter, changeFilter }) {
  return (
    <div className="flex items-center gap-4">
      <span className="font-semibold text-[#000000] text-[20px]">Showing:</span>
      <div className="relative">
        <select
          value={filter}
          onChange={changeFilter}
          className="text-[#400167] border bg-[#F4F4F4] rounded-lg py-3 px-4 w-[248px] font-bold"
        >
          <option value="Lessons">Lessons</option>
          <option value="Exams">Exams</option>
          <option value="Classrooms">Classrooms</option>
        </select>
      </div>
    </div>
  );
}

function Table({ students, onViewPerformance }) {
  return (
    <table className="min-w-full bg-white">
      <thead>
        <tr>
          <th className="py-2 px-4 bg-purple-100 text-left text-[#400167] text-[16px] font-semibold">
            Name
          </th>
          <th className="py-2 px-4 bg-purple-100 text-left text-[#400167] text-[16px] font-semibold">
            Email Address
          </th>
          <th className="py-2 px-4 bg-purple-100 text-left text-[#400167] text-[16px] font-semibold">
            Username
          </th>
          <th className="py-2 px-4 bg-purple-100 text-left text-[#400167] text-[16px] font-semibold">
            Action
          </th>
        </tr>
      </thead>
      <tbody>
        {students.map((student, index) => (
          <Student
            key={index}
            student={student}
            onViewPerformance={onViewPerformance}
          />
        ))}
      </tbody>
    </table>
  );
}

function Student({ student, onViewPerformance }) {
  return (
    <tr>
      <td className="py-4 px-4 text-[14px]">{student.name}</td>
      <td className="py-4 px-4 text-[14px]">{student.email}</td>
      <td className="py-4 px-4 w-1/2 text-[14px]">{student.username}</td>
      <td className="py-4 px-4 text-[14px]">
        <button
          onClick={onViewPerformance}
          className="bg-[#DDD3FF] text-[#5002D0] py-2 px-4 rounded-lg hover:bg-purple-200 font-semibold text-[14px]"
        >
          View performance
        </button>
      </td>
    </tr>
  );
}
